import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useReleaseConfirmation = (
  isLoading,
  isStartAssessment,
  transactionStatus,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isAllowed = true;

  const isStatusAllowed = ['FOR DELIVERY'].indexOf(transactionStatus) > -1;

  const showComponent = isAllowed && !isStartAssessment && isStatusAllowed;

  const onHandleClick = (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want received this application?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const component = showComponent ? (
    <button
      disabled={isLoading}
      onClick={onHandleClick}
      type="button"
      className="btn btn-success font-weight-bold text-dark"
    >
      {isLoading && (
        <>
          <i className="fas fa-spinner fa-spin" />
          &nbsp;
        </>
      )}
      Receive
    </button>
  ) : null;

  return {
    isAllowed,
    onHandleClick,
    component,
  };
};

export default useReleaseConfirmation;
